<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!--
            <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button>
            -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.push('/yacht-list')">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="0"></bg>
      <!-- {{ $store.state }} -->
      <ion-grid>
        <ion-row class="mt-20">
          <ion-col size="12">
            <div class="title">{{ name }}</div>
          </ion-col>
          <ion-col size="12">
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push({name: 'report', params: { id: id } });"><img src="../assets/svg/icon-list.svg"></ion-button>
              <div class="btn-squared-label">Report</div>
              <!--
                <div v-if="$store.state.user_role != 'client'" class="btn-squared-link" @click="$router.push({name: 'new-yacht-index', params: { id: id, back: true } });">Edit</div>
              -->
            </div>
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push({name: 'worklists', params: { id: id } });"><img src="../assets/svg/icon-worklist.svg"></ion-button>
              <div class="btn-squared-label">Work list</div>
            </div>
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push({name: 'files', params: { home: id } });"><img src="../assets/svg/icon-docs.svg"></ion-button>
              <div class="btn-squared-label">Documents</div>
            </div>
            <div class="btn-squared-wrapper">
              <ion-button class="btn-squared" @click="$router.push({ name: 'new-yacht-specifications', params: { id: id, back: true } });"><img src="../assets/svg/icon-info.svg"></ion-button>
              <div class="btn-squared-label">Information</div>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
// import Vue from "vue"
import axios from "axios"
export default {
  name: "YachtDetails",
  data: function() {
    return {
      id: this.$route.params.id,
      loader: true,
      name: ''
    }
  },
  mounted: function() {
    axios.post(this.apiUrl + '/api/v1/get-yacht', { api_token: this.$store.state.api_token, id: this.id })
    .then((response) => {
      let res = response.data
      if(res.data) {
        this.name = res.data.name
      }
      this.loader = false;
    })

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>